import React from "react";
import { Container } from "reactstrap";
import CandidateGridDetails from "./CandidateGridDetails";
import Section from "./Section";

const CandidateGrid = () => {
  document.title = "Avanza | Candidatos";
  return (
    <React.Fragment>
      <Section />
      <section className="section">
        <Container>
          <CandidateGridDetails />
        </Container>
      </section>
    </React.Fragment>
  );
};

export default CandidateGrid;
